<template>
  <div class="container-fluid px-0">
    <h2 class="page-title text-center">VERIFICACIÓN DE PAGO</h2>
    <br>
    <div class="container-fluid">
      <div class="row d-flex px-lg-5">
        <div class="col-12 padding-div-low">
          <div  v-if="Recibo && Pagos && Imputado" class="area-claro div-principal-VerificacionPago" :key="index">
            <img class="logo" src="..\..\..\..\assets\logo-pj-transparente-negro-recibo.png" alt="logo" >
            <h4 style="color: black; text-align: center">PAGO REALIZADO</h4>
            <table style="width: 100%" class="table">
              <tr><td>FECHA EN QUE SE REGISTRÓ EL PAGO: </td><td class="Recibo">{{FechaAPalabras(Recibo.FechaDePago)}}</td></tr>
              <tr><td>JUZGADO: </td><td class="Recibo">{{Recibo.Expediente.Area.Nombre}}</td></tr>
              <tr><td>{{Recibo.Expediente.TipoDocumento.Nombre  + ': '}} </td><td class="Recibo"> {{((Recibo.Expediente.NumeroRomano == null) ? Recibo.Expediente.Consecutivo : Recibo.Expediente.Consecutivo +"-"+ Recibo.Expediente.NumeroRomano)}}</td></tr><br>
              <tr><td>NOMBRE: </td><td  class="Recibo"> {{ Imputado.Nombre +" "+
            (Imputado.ApellidoPaterno == null ? "" : Imputado.ApellidoPaterno) +" "+ 
          (Imputado.ApellidoMaterno == null ? "" : Imputado.ApellidoMaterno)}}</td></tr>
          <tr><td></td></tr><br>
          <tr><td>CONCEPTO(S)</td><td style=" text-align: right">IMPORTE POR CONCEPTO</td></tr><br>
          <tr v-for="(rubro, indexR) in Pagos" style=""><td>{{rubro.RubroDBPJ.Nombre.toUpperCase()}}</td>
            <td style="text-align: right">{{"$"+agregarCeros(rubro.Monto) }} </td></tr><br>
            <tr><td>TOTAL</td><td style=" text-align: right">{{"$"+agregarCeros(total)}}</td></tr>
            <tr><td colspan="2" style="text-align: right;">({{numerosAPalabras(total) + (total == 1 ? ' PESO' : ' PESOS') + ' ' +(total % 1).toFixed(2).substring(2) + '/100 M.N.'}})</td></tr>
            </table>
          </div>
          <div v-else-if="mensajeerror" class="area-claro div-principal-VerificacionPago" :key="index">
            <h4 style="color: black; text-align: center">PAGO NO ENCONTRADO</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import func from '../../../SIVAC/Comun/Funciones/comun.js'

  export default {
    data() {
      return {
        enumeraciones,
        enumeraciones_sicpo,
        nombreDeVariableDelComponente: "cargoPaginaOficial",
        qr: String,
        mensajeerror: null,
        Pagos:null,
        Imputado: null,
        Recibo: {
          Expediente:{
            Area:{},
            TipoDocumento:{}
          },
          FechaDePago:String,
          Hash: ""
        },
        index: 0,
        urlVerificar : String
      }
    },

    computed: {
      total(){//ir sumando cada monto
        if(this.Pagos){
          return this.Pagos.reduce((sum, Pagos)=>{
            return sum + Pagos.Monto
          }, 0)
        }
      }
    },

    beforeMount(){
      //
      this.qr = this.$route.query.qr
        const parametros = 
        {    
          Hash: this.qr                          
        }

        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);   

        var conexion = api.conexion + api.SIVAC.sistema.caja.pagos.BuscarPagosQR

        axios.post(conexion, parametros, headerPeticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.mensajeerror= respuesta.data.Error.Mensaje;

            } else {
              this.Imputado = respuesta.data.Pagos[0].Persona;
              this.Recibo = respuesta.data.Pagos[0];
              this.Pagos = respuesta.data.Pagos;
              //     this.index += 1; por si falla al recargar descomentar
              //console.log(this)
            }
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
    },

    mounted() {
      this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
      
    },


    methods: {
      FechaAPalabras: function(fecha){
          return func.FechaAPalabras(fecha)
      },
      agregarCeros : function(monto){
          return func.agregarCeros(monto)
      },
      numerosAPalabras: function(numero){
          return func.numerosAPalabras(numero)
      },
    }
  }
</script>

<style scoped>
  .page-title {
    background-color: rgb(33,33,33);
    color: #FFF;
    padding: 2vh 20vw;
  }

  .div-principal-VerificacionPago .alert-dark {
    color: white;
    background-color: #545757;
    border-color: #c6c8ca;
  }

  .alert-info-VerificacionPago p > span {
    font-weight: 900;
    font-size: 1.3em;
  }

  @media(max-width: 991px) {
    #realizarLaVerificacionPago_div {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  @media(max-width: 554px){
    .Recibo{
      text-align: right;
    }
    .logo{
      margin: auto;
      display: block;
    }
  }
  .logo{
    height: 100px; 
    width: 150px;
  }
</style>





// WEBPACK FOOTER //
// src/components/PaginaOficial/Funciones/VerificacionDePagos/VerificacionDePagos.vue